import React from "react";
import Editor from "shared/components/Editor/Editor";
import styled from "styled-components/macro";

function Descriptions({ object, update, attribute, placeholder, mode }) {
	const [descriptions, setDescriptions] = React.useState(object?.[attribute]);

	const handleBlur = () => {
		const item = { ...object, [attribute]: descriptions.truncate(19999,true) };
		if (descriptions !== object[attribute]) update({ item, modifiedAttribNames: [attribute] });
	};

	return <EditorWrapperOutline>
		<Editor value={descriptions} onChange={setDescriptions} onUpdate={handleBlur} placeholder={placeholder} disabled={mode.IsViewer()} />
	</EditorWrapperOutline>

}

Descriptions.displayName = "Descriptions";
export default Descriptions;
const EditorWrapperOutline = styled.div`
border-radius: 4px;
        width: 100%;
        min-height: 60px;
        padding: 4px;
        border: 1px solid transparent;
        ::before {
            font-style: italic !important;
            color: #C4C4C4 !important;
            font-weight: 300;
            line-height: 150%; /* 21px */
            font-size: 14px;

        }
         :hover {

            border: 1px solid #605F60;
        }
        :focus-within {
            border: 1px solid #605F60;

        }
`;
